import { render, staticRenderFns } from "./EntityList.vue?vue&type=template&id=d3c4bbbc&lang=pug"
import script from "./EntityList.vue?vue&type=script&lang=js"
export * from "./EntityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3c4bbbc')) {
      api.createRecord('d3c4bbbc', component.options)
    } else {
      api.reload('d3c4bbbc', component.options)
    }
    module.hot.accept("./EntityList.vue?vue&type=template&id=d3c4bbbc&lang=pug", function () {
      api.rerender('d3c4bbbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/components/EntityList.vue"
export default component.exports